'use client'

import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'

export default function useQueryStringParams() {
	const [params, setParams] = useState({})

	const { pathname } = useLocation()

	useEffect(() => {
		const search = window.location.search
		const params = new URLSearchParams(search)
		const data = Object.fromEntries(params.entries())
		setParams(data)
	}, [pathname])

	return params
}
